export default class CopyButton {
    private button: HTMLButtonElement;

    constructor(button: HTMLButtonElement) {
        this.handleClick = this.handleClick.bind(this);

        this.button = button;
        this.button.addEventListener('click', this.handleClick);
    }

    handleClick() {
        navigator.clipboard.writeText(this.content).catch(error => {
            console.error(error);
        });
    }

    get content() {
        return (this.target.textContent || '').trim();
    }

    get target() {
        if (!this.button.dataset.copy) {
            throw new Error(`The data-copy attribute is required on the copy button`);
        }

        const target = document.getElementById(this.button.dataset.copy);

        if (target === null) {
            throw new Error(`The ${this.button.dataset.copy} element does not exist`);
        }

        return target;
    }

    static createFromSelector(selector: string) {
        return Array.from(document.querySelectorAll<HTMLButtonElement>(selector)).map(button => {
            return new CopyButton(button);
        });
    }
}
